module.exports = "<div class=\"header-login\">\n    <div class=\"dropdown {{ cssClass }}\">\n        <a href=\"javascript:void(0)\" role=\"button\" id=\"dropdownMenuLink\" (click)=\"clickDropDown()\">{{ username }}</a>\n\n        <div class=\"dropdown-menu {{ cssClass }}\">\n            <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"logOut()\"><i class=\"icon-lock\"></i> ログアウト</a>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/elements/pageNavBarHeader/pageNavBarHeader.component.html
// module id = ./src/app/component/elements/pageNavBarHeader/pageNavBarHeader.component.html
// module chunks = main